import { addItemToCart } from "../../components/Cart/cartRepo";

/**
 * Create Event for CartDrawer and CartCount button components
 */
const addProductToCart = (event: Event) => {
  // build `add to cart` request from html elements
  const target = event.target as HTMLButtonElement;
  const container = target.parentElement as HTMLElement;

  const targetProductName = container.querySelector(".name") as HTMLSpanElement;

  const targetProductImageSrc = container.querySelector(
    ".listimg"
  ) as HTMLImageElement;

  const targetProductPrice = container.querySelector(
    ".price"
  ) as HTMLSpanElement;

  const addToCartEvent = new CustomEvent("addToCart", {
    detail: {
      productName: targetProductName.innerText,
      productImageSrc: targetProductImageSrc.src,
      productPrice: targetProductPrice.innerText,
    },
  });

  if (target) {
    if (target.dataset.productid) {
      const promise = addItemToCart({
        ProductId: parseInt(target.dataset.productid, 10),
        Quantity: 1,
      });
      //updated the cart count when the item is added
      //emit the addToCart event
      promise.then(() => document.dispatchEvent(addToCartEvent));
    }
  }
  if ("vibrate" in navigator) {
    const vibrationPattern: number[] = [10, 50, 10];
    navigator.vibrate(vibrationPattern);
  }
};

/**
 * Attach event to elements with `add-to-cart` className
 */

const products: NodeListOf<HTMLButtonElement> = document.querySelectorAll(
  ".add-to-cart"
) as NodeListOf<HTMLButtonElement>;
const productsArray: Array<HTMLButtonElement> = Array.from(products);

productsArray.forEach((product) => {
  product.addEventListener("click", addProductToCart);
});
